module.exports = __webpack_public_path__ + "images/the-binge-watcher-b5f808322a1494fda1325a6c791f6f5e.png";